import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ofwca} from '../../../shared/interface/ofwca';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {MatSnackBar} from '@angular/material/snack-bar';

export interface ChangeRegionalDialogData {
  ofwcaObject: Ofwca;
}

@Component({
  selector: 'app-change-regional-dialog',
  templateUrl: './change-regional-dialog.component.html',
  styleUrls: ['./change-regional-dialog.component.scss']
})
export class ChangeRegionalDialogComponent implements OnInit, OnDestroy {

  changeRegionalForm: FormGroup;
  changeAssetsRegionalControl: FormControl;
  changeLifeRegionalControl: FormControl;
  assetsRegionalControl: FormControl;
  lifeRegionalControl: FormControl;
  changeActiveRegistrationsControl: FormControl;
  changeArchivalRegistrationsControl: FormControl;
  ofwcaObject: Ofwca;
  formErrors = {};
  processingRequest = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangeRegionalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegionalDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
  ) {
    this.ofwcaObject = data.ofwcaObject;
    this.changeRegionalForm = fb.group({
      changeAssetsRegional: this.changeAssetsRegionalControl = fb.control(false),
      changeLifeRegional: this.changeLifeRegionalControl = fb.control(false),
      assetsRegional: this.assetsRegionalControl = fb.control(''),
      lifeRegional: this.lifeRegionalControl = fb.control(''),
      changeActiveRegistrations: this.changeActiveRegistrationsControl = fb.control(false),
      changeArchivalRegistrations: this.changeArchivalRegistrationsControl = fb.control(false),
    });
    this.assetsRegionalControl.disable();
    this.lifeRegionalControl.disable();
  }

  ngOnInit(): void {
    this.changeAssetsRegionalControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (!val) {
          this.assetsRegionalControl.disable();
        } else {
          this.assetsRegionalControl.enable();
        }
      });

    this.changeLifeRegionalControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (!val) {
          this.lifeRegionalControl.disable();
        } else {
          this.lifeRegionalControl.enable();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.changeRegionalForm, this.formErrors);
    this.formErrors = {};

    this.ofwcaService.changeRegional(this.changeRegionalForm.value, this.ofwcaObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt OFWCA', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas aktualizacji obiektu OFWCA wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.changeRegionalForm, this.formErrors);
        }
      })
    ;
  }
}
